import React, { Component } from 'react';
interface ChartWrapperProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  height?: number;
  footer?: string;
}
/**
 * Chart Wrapper Component
 * Provides consistent styling and structure for all chart visualizations
 */
export function ChartWrapper({
  title,
  subtitle,
  children,
  height = 300,
  footer
}: ChartWrapperProps) {
  return <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-6" data-id="element-94">
      {/* Header */}
      <div className="mb-6" data-id="element-95">
        <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-96">{title}</h3>
        {subtitle && <p className="text-sm text-gray-600" data-id="element-97">{subtitle}</p>}
      </div>
      {/* Chart Content */}
      <div style={{
      height: `${height}px`
    }} data-id="element-98">
        {children}
      </div>
      {/* Footer */}
      {footer && <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-99">
          <p className="text-xs text-gray-500 italic" data-id="element-100">{footer}</p>
        </div>}
    </div>;
}